import { createSlice } from '@reduxjs/toolkit';

export const campaign = createSlice({
    name: "campaign",

    initialState: {
        completed: false,
        description: null,
        hasPassword: false,
        registered: false,
        phoneNumber: "",
        userName: "",
        firstName: "",
        lastName: '',
        Token: "",
        loading: false,
        JWT: "",
        resetOtp: false,
        timeLeft: 120,
        gameTime: 180,
        step: 1,
        answers: [],
        hasAnswer: false,
        finalResult: {},
        isLogin: false,
        referralCode: "",
        VoucherCode: "",
        VoucherAmount: "",
        score: null,
        chargeAmount: null,
        results: {},
        info: null,
        series: null
    },
    reducers: {

        CAMPAIGN_COMPLETED: (state, action) => {
            return {
                ...state, completed: action.payload
            }
        },
        CAMPAIGN_RESULTS: (state, action) => {
            return {
                ...state, results: action.payload
            }
        },
        CAMPAIGN_INFO: (state, action) => {
            return {
                ...state, info: action.payload
            }
        },
        CAMPAIGN_GAME_TIME_LEFT: (state, action) => {
            return {
                ...state, gameTime: state.gameTime - 1
            }
        },

        CAMPAIGN_RESET_GAME_TIME: (state, action) => {
            return {
                ...state, gameTime: 180
            }
        },

        CAMPAIGN_DESCRIPTION: (state, action) => {
            return {
                ...state, description: action.payload
            }
        },

        CAMPAIGN_HAS_PASSWORD: (state, action) => {
            return {
                ...state, hasPassword: action.payload
            }
        },

        CAMPAIGN_REGISTERED: (state, action) => {
            return {
                ...state, registered: action.payload
            }
        },


        CAMPAIGN_STEP_HANDLER: (state, action) => {
            return {
                ...state, step: action.payload
            }
        },


        CAMPAIGN_OTP: (state, action) => {
            return { ...state, Token: action.payload }
        },

        CAMPAIGN_PHONE_NUMBER: (state, action) => {
            return {
                ...state, phoneNumber: action.payload
            }
        },

        CAMPAIGN_LOADING: (state, action) => {
            return {
                ...state, loading: action.payload
            }
        },

        CAMPAIGN_JWT: (state, action) => {
            return {
                ...state, JWT: action.payload
            }
        },

        CAMPAIGN_RESET_OTP: (state, action) => {
            return {
                ...state, resetOtp: action.payload
            }
        },


        CAMPAIGN_OTP_TIME_LEFT: (state, action) => {
            return {
                ...state, timeLeft: state.timeLeft - 1
            }
        },
        CAMPAIGN_RESET_TIME: (state, action) => {
            return {
                ...state, timeLeft: 120
            }
        },
        CAMPAIGN_RESET_OTP_TIME_LEFT: (state, action) => {
            return {
                ...state, timeLeft: 120
            }
        },

        CAMPAIGN_SET_NAME: (state, action) => {
            return {
                ...state, userName: action.payload
            }
        },

        CAMPAIGN_ANSWER_HAS_VALUE: (state, action) => {
            return {
                ...state, hasAnswer: action.payload
            }
        },

        CAMPAIGN_SET_LOGIN: (state, action) => {

            return {
                ...state, isLogin: action.payload
            }
        },
        CAMPAIGN_REFERRAL_CODE: (state, action) => {

            return {
                ...state, referralCode: action.payload
            }
        },
        CAMPAIGN_VOUCHER_CODE: (state, action) => {

            return {
                ...state, VoucherCode: action.payload
            }
        },

        CAMPAIGN_SET_RESULT: (state, action) => {
            return {
                ...state, finalResult: action.payload
            }
        },

        CAMPAIGN_VOUCHER_AMOUNT: (state, action) => {

            return {
                ...state, VoucherAmount: action.payload
            }
        },
        CAMPAIGN_LOG_OUT: (state, action) => {

            return {
                phoneNumber: "",
                userName: "",
                firstName: "",
                lastName: "",
                Token: "",
                loading: false,
                JWT: "",
                resetOtp: false,
                timeLeft: 120,
                answers: [],
                hasAnswer: false,
                finalResult: {},
                isLogin: false,
                referralCode: "",
                VoucherCode: "",
                info: null,
                VoucherAmount: ""
            }
        },
        CAMPAIGN_ANSWER: (state, action) => {

            return {
                ...state,
                answers: [...state.answers, ...action.payload]
            }
        },
        RESET_ANSWERS: (state, action) => {
            return {
                ...state,
                answers: []
            }
        },
        CAMPAIGN_USER_FIRST_NAME: (state, action) => {

            return {
                ...state, firstName: action.payload,
            }
        },
        CAMPAIGN_USER_LAST_NAME: (state, action) => {

            return {
                ...state, lastName: action.payload,
            }
        },
        SET_SCORE: (state, action) => {
            return {
                ...state, score: action.payload,
            }
        },
        SET_CHARGE_AMOUNT: (state, action) => {
            return {
                ...state, chargeAmount: action.payload,
            }
        },
        SET_SERIES: (state, action) => {
            return {
                ...state, series: action.payload,
            }
        },
    }
})
export const {
    CAMPAIGN_OTP,
    CAMPAIGN_PHONE_NUMBER,
    CAMPAIGN_LOADING,
    CAMPAIGN_JWT,
    CAMPAIGN_RESET_OTP,
    CAMPAIGN_OTP_TIME_LEFT,
    CAMPAIGN_RESET_OTP_TIME_LEFT,
    CAMPAIGN_SET_NAME,
    CAMPAIGN_ANSWER_HAS_VALUE,
    CAMPAIGN_SET_RESULT,
    CAMPAIGN_SET_LOGIN,
    CAMPAIGN_REFERRAL_CODE,
    CAMPAIGN_VOUCHER_CODE,
    CAMPAIGN_VOUCHER_AMOUNT,
    CAMPAIGN_LOG_OUT,
    CAMPAIGN_ANSWER,
    CAMPAIGN_USER_FIRST_NAME,
    CAMPAIGN_USER_LAST_NAME,
    CAMPAIGN_RESET_TIME,
    CAMPAIGN_COMPLETED,
    CAMPAIGN_DESCRIPTION,
    CAMPAIGN_HAS_PASSWORD,
    CAMPAIGN_REGISTERED,
    CAMPAIGN_STEP_HANDLER,
    CAMPAIGN_GAME_TIME_LEFT,
    CAMPAIGN_RESET_GAME_TIME,
    RESET_ANSWERS,
    SET_SCORE,
    SET_CHARGE_AMOUNT,
    CAMPAIGN_INFO,
    CAMPAIGN_RESULTS,
    SET_SERIES
} = campaign.actions;
export default campaign.reducer